import styled from "styled-components";
import { VideocamOutlined } from "@material-ui/icons";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const PreviewPlayer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 60%;
`;

export const PreviewContainer = styled.div`
  display: flex;
  width: 80%;
  height: 40%;
  align-items: center;
  justify-content: space-around;
  overflow: auto;
`;

export const PreviewList = styled.div`
  display: flex;
  width: 50%;
  flex-wrap: wrap;
  gap: 14px;
`;

export const Actions = styled.div`
  margin-left: 10px;
  justify-content: flex-end;
  align-items: center;
  display: flex;

  .MuiBadge-badge {
    border-radius: 50%;
    width: 35px;
    height: 35px;
    font-size: 18px;
    top: 10%;
    right: 5%;
  }
`;

export const MinPreview = styled.div`
  margin: 0px;
  width: 70px;
  height: 70px;

  border-radius: 15px;
  border: 1px solid;
  border-color: #3d9be9;

  ${(props) =>
    props.selected &&
    `
      border-width: 5px;
      border: solid;
      border-color: var(--secondary);
    `}

  cursor: pointer;

  :hover .remove-video {
    visibility: visible;
  }

  .remove-video {
    visibility: hidden;
    margin-right: 2px;
    width: 5px;
    height: 5px;
    background-color: var(--c2s-red);

    position: relative;
    bottom: 76px;
    left: 42px;
  }
`;

export const AddNewVideo = styled.label`
  min-width: 70px;
  min-height: 70px;

  border-radius: 15px;
  border: 1px solid;
  border-color: #999;

  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;
`;

export const GetThumbnailVideo = styled.video`
  width: 100%;
  height: 100%;
`;

export const VideoButton = styled.label`
  background: #fdab1e;
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  border-radius: 50%;
  cursor: pointer;

  transition: filter 0.5s;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const VideoCameraIcon = styled(VideocamOutlined).attrs({
  size: 22,
})`
  color: #ffffff;
`;
